(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire761b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire761b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eKpYu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc98293c451d2b0$export$2e2bcd8739ae039; });
class $abc98293c451d2b0$var$NgConfig {
}
$abc98293c451d2b0$var$NgConfig.UPLOAD_URL = "/api/userfiles/";
$abc98293c451d2b0$var$NgConfig.JOB_START_URL = "/api/jobs/start/";
$abc98293c451d2b0$var$NgConfig.JOB_STATUS_URL = "/api/jobs/status/";
$abc98293c451d2b0$var$NgConfig.FILES_URL = "/userfiles";
$abc98293c451d2b0$var$NgConfig.PARAMS_URL = "/tools/params";
$abc98293c451d2b0$var$NgConfig.FILES_API_URL = "/api/userfiles";
$abc98293c451d2b0$var$NgConfig.MAX_UPLOAD_FILE_SIZE = 1073741824;
$abc98293c451d2b0$var$NgConfig.MAX_NUMBER_OF_BATCH_UPLOADS = 10;
var $abc98293c451d2b0$export$2e2bcd8739ae039 = $abc98293c451d2b0$var$NgConfig;

});


var $eKpYu = parcelRequire("eKpYu");
class $ac83c500eb7c9f5a$var$MyFilesList {
    constructor(options){
        this.content = null;
        this.csrfToken = options.csrfToken;
        this.fetchCron = setInterval(this.fetchContent.bind(this), 60000);
        this.toolId = options.toolId;
        this.options = options;
    }
    on(eventName, callback) {
        document.addEventListener(eventName, callback);
    }
    off(eventName, callback) {
        document.removeEventListener(eventName, callback);
    }
    off_all_events() {
        document.removeEventListener("fileSelected", ()=>{});
        document.removeEventListener("fileDeleted", ()=>{});
        document.removeEventListener("fileListUpdated", ()=>{});
    }
    _dispatchEvent(eventName, detail) {
        document.dispatchEvent(new CustomEvent(eventName, {
            detail: detail
        }));
    }
    async handleDeleteBulk(shortIds) {
        await this.deleteBulk(shortIds);
    }
    handleDeleteOne(shortId) {
        this.deleteOne(shortId);
    }
    handleSelectOne(shortId) {
        this._dispatchEvent("fileSelected", {
            shortIds: [
                shortId
            ]
        });
    }
    handleDownloadOne(url, name) {
        fetch(url).then((response)=>response.blob()).then((blob)=>{
            const blobURL = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobURL;
            if (name && name.length) a.download = name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            eventRecorder.captureEvent("file_downloaded");
        }).catch((e)=>alert("Download failed: " + e.message));
    }
    async fetchContent() {
        this.content = null;
        let response = null;
        try {
            response = await fetch(`${(0, $eKpYu.default).FILES_URL}/tool/${this.toolId}/`, {
                method: "GET",
                headers: {
                    accept: "application/html"
                }
            });
        } catch (e) {
            console.error(e);
            this.content = "Error fetching file list";
        }
        if (response && !response.ok) {
            console.error(response.statusText);
            this.content = "Error fetching file list";
        }
        if (response && response.ok) this.content = await response.text();
        // if (!response.ok)
        //   throw new Error(`Unsuccessful request: ${response.statusText}`)
        // this.content = await response.text()
        const listContent = document.getElementById("file-list-content");
        if (listContent) {
            listContent.innerHTML = this.content || "";
            listContent.focus();
        }
        this._dispatchEvent("fileListUpdated", {});
    }
    getContent() {
        return this.content;
    }
    async deleteBulk(shortIds) {
        const deleted = [];
        shortIds.forEach(async (shortId)=>{
            try {
                await this.deleteOne(shortId);
                deleted.push(shortId);
            } catch (e) {
                console.error(e);
            }
        });
        eventRecorder.captureEvent("files_deleted", {
            deleted: deleted,
            gotAll: shortIds.length === deleted.length
        });
        await this.fetchContent();
    }
    async deleteOne(shortId) {
        const response = await fetch(`${(0, $eKpYu.default).FILES_API_URL}/${shortId}/`, {
            method: "DELETE",
            headers: {
                accept: "application/json",
                "content-type": "application/json",
                "X-CSRFToken": this.csrfToken
            }
        });
        if (!response.ok) throw new Error(`Unsuccessful request: ${response.statusText}`);
        eventRecorder.captureEvent("file_deleted");
        this.fetchContent();
    }
    init() {
        document.addEventListener("DOMContentLoaded", ()=>{
            this.on("fileListUpdated", (e)=>{
                this.off_all_events();
                document.getElementById("delete-button")?.addEventListener("click", ()=>{
                    const shortIds = Array.from(document.querySelectorAll("button.trashit")).map((button)=>button.dataset.shortid);
                    this.handleDeleteBulk(shortIds);
                });
                const deleteOneButtons = document.querySelectorAll("button.trashit");
                deleteOneButtons.forEach((button)=>{
                    button.addEventListener("click", (e)=>{
                        this.handleDeleteOne(e.currentTarget?.dataset.shortid);
                    });
                });
                const downloadButtons = document.querySelectorAll("button.downloadit");
                downloadButtons.forEach((button)=>{
                    button.addEventListener("click", (e)=>{
                        if (e.currentTarget && e.currentTarget instanceof HTMLElement && e.currentTarget.dataset.url && e.currentTarget.dataset.name) this.handleDownloadOne(e.currentTarget.dataset.url, e.currentTarget.dataset.name);
                    });
                });
                const selectButtons = document.querySelectorAll("a.selectit");
                selectButtons.forEach((button)=>{
                    button.addEventListener("click", (e)=>{
                        e.preventDefault();
                        this.handleSelectOne(e.currentTarget?.dataset.shortid);
                    });
                });
            });
        });
    }
}
var $ac83c500eb7c9f5a$export$2e2bcd8739ae039 = $ac83c500eb7c9f5a$var$MyFilesList;
// Params are loaded by a previous inline script
// @ts-ignore
const $ac83c500eb7c9f5a$var$myFilesList = new $ac83c500eb7c9f5a$var$MyFilesList({
    csrfToken: csrf,
    toolId: tool_id
});
$ac83c500eb7c9f5a$var$myFilesList.init();
$ac83c500eb7c9f5a$var$myFilesList.on("fileSelected", (e)=>{
    const shortIds = e.detail.shortIds;
    //console.log('fileSelectedfdfsdf', shortIds)
    eventRecorder.captureEvent("file_selected", {
        ids: shortIds
    });
    // @ts-ignore
    window.location.replace(`/tools/${refname}/params` + "?short_ids=" + shortIds.join(","));
});
$ac83c500eb7c9f5a$var$myFilesList.fetchContent();

})();
//# sourceMappingURL=filelist.js.map
